import {WIDGET_KEYS} from "../../other/constants/WidgetKeys.jsx";
import {SwivuRichTextEditorWidget} from "./extendingClasses/SwivuRichTextEditorWidget.jsx";
import {getNotes, updateNotes} from "../../network/network.jsx";
import {showToast} from "../../other/utils/utils.jsx";

export class SwivuRichTextEditorManager extends SwivuRichTextEditorWidget {
  static get $name() {
    return "swivurichtexteditormanager";
  }

  static get type() {
    return WIDGET_KEYS.swivuRichTextEditorManager;
  }

  async loadRecord(record, context) {
    this.swivNoteRecord = record;
    Object.assign(this, context)

    if (!record.isPhantom) {
      await this.loadNote(record);

      const canEditNote = context.user.can(record.canEdit);
      if (!canEditNote) {
        super.swivuSetNoteReadOnly(true);
      }
    }
  }

  async loadNote(record) {
    try {
      this.swivuLoadNoteController = new AbortController();
      const { data } = await getNotes(record.id, this.swivuLoadNoteController);
      if (data) {
        super.swivuSetNoteData(data.content);
      }
    } catch (err) {
      if (err?.message === "canceled") return;
      console.error(err);
      showToast({
        msg: "Something went wrong! unable to retrieve note",
        type: "error",
      })
    }
  }

  async saveNote() {
    const notesData = this.swivuGetNoteData();
    try {
      const persistNote = async (record) => {
        await updateNotes(record.id, {
          board: this.swivNoteRecord.boardId,
          archived: false,
          content: notesData
        });
      }

      if (this.swivNoteRecord.isPhantom) {
        await new Promise((res) => {
          this.project.boardNotesStore.on({
            idChange({ record }) {
              persistNote(record);
              res();
            },
            once: true,
          }, this);
          this.project.boardNotesStore.add(this.swivNoteRecord);
        });
      } else {
        await persistNote(this.swivNoteRecord);
      }


    } catch (err) {
      console.error(err);
      showToast({
        msg: "Something went wrong! unable to save note",
        type: "error",
      })
      throw err;
    }
  }
}

SwivuRichTextEditorManager.initClass();